/**
 * ModeIndicator.js
 * Reusable component showing DEMO vs LIVE mode on every sub-page.
 * Import and add to any sub-page header.
 * Usage: <ModeIndicator />
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { getUserRole } from "../../security/roleManager";
import { ROLES } from "../../security/roles";

const PAID_ROLES = [ROLES.CUSTOMER_USER, ROLES.CUSTOMER_ADMIN, ROLES.FENTASAFE_ADMIN];

export default function ModeIndicator() {
  const { t } = useTranslation();
  const role = getUserRole();
  const isLive = PAID_ROLES.includes(role);

  return (
    <div style={{
      display: "inline-flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "6px 14px",
      borderRadius: 8,
      background: isLive ? "rgba(22,163,74,0.15)" : "rgba(251,191,36,0.1)",
      border: `1px solid ${isLive ? "rgba(22,163,74,0.4)" : "rgba(251,191,36,0.3)"}`,
      minWidth: 80,
    }}>
      <div style={{ fontSize: "0.6rem", color: "#64748b", textTransform: "uppercase", letterSpacing: 1 }}>
        {t("commandCenter.modeIndicator.mode")}
      </div>
      <div style={{ fontWeight: 700, color: isLive ? "#22c55e" : "#fbbf24", fontSize: "0.9rem" }}>
        {isLive ? "🟢 LIVE" : "🟡 DEMO"}
      </div>
      <div style={{ fontSize: "0.6rem", color: "#64748b" }}>
        {isLive ? t("commandCenter.modeIndicator.realData") : t("commandCenter.modeIndicator.simulated")}
      </div>
    </div>
  );
}
